import { useIntl } from '@mfw/components';

import { Dialog } from '../../../components';
import messages from './messages';

export interface RemoveUploadDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
  open: boolean;
}

export const RemoveUploadDialog = ({
  onCancel,
  onConfirm,
  open,
}: RemoveUploadDialogProps) => {
  const { formatMessage } = useIntl();
  return (
    <Dialog
      description={formatMessage(messages.description)}
      title={formatMessage(messages.title)}
      onConfirm={onConfirm}
      onClose={onCancel}
      open={open}
    />
  );
};
